"use client";
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { listMissingVariables } from "../../../../utils/index.js";
import { useState, useRef, useEffect } from "react";
import { Skeleton } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../../Analytics/index.js";
import { LocationSelectorButton } from "../../LocationSelector/index.js";
import { OpeningHours } from "../../OpeningHours/index.js";
import { COMPONENT_NAME, COMPOSABLE_DATA_MY_WAREHOUSE, COMPOSABLE_DATA_ICON_TITLE, COMPOSABLE_DATA_CHANGE_MY_WAREHOUSE, COMPOSABLE_DATA_SET_MY_WAREHOUSE, COMPOSABLE_DATA_ARIA_LABEL } from "./constants.js";
import { MainContainer, StyledWarehouseIcon, StyledLocationIcon } from "./styles.js";
const composableData = {
  COMPOSABLE_DATA_ICON_TITLE: "",
  COMPOSABLE_DATA_MY_WAREHOUSE: "",
  COMPOSABLE_DATA_SET_MY_WAREHOUSE: "",
  COMPOSABLE_DATA_CHANGE_MY_WAREHOUSE: ""
};
function WarehouseSelectorUI({
  displayOpenHours,
  moduleSettings,
  preferredWarehouse,
  onClick,
  showLabel,
  drawerType = "FMW",
  stockStatusData,
  analyticsIdentifier
}) {
  var _a, _b;
  const [isMounted, setIsMounted] = useState(false);
  const [shouldShowHours, setShouldShowHours] = useState(true);
  const timeoutId = useRef(null);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const isCMW = drawerType === "CMW";
  const showOpeningHours = displayOpenHours && isMounted && preferredWarehouse && preferredWarehouse.hours;
  useEffect(() => {
    if (timeoutId.current) clearTimeout(timeoutId.current);
    setShouldShowHours(true);
    timeoutId.current = setTimeout(() => {
      setShouldShowHours(!!(preferredWarehouse == null ? void 0 : preferredWarehouse.hours));
      if (timeoutId.current) clearTimeout(timeoutId.current);
    }, 3e3);
    return () => {
      if (timeoutId.current) clearTimeout(timeoutId.current);
    };
  }, [timeoutId, preferredWarehouse]);
  const missingProps = listMissingVariables({
    moduleSettings,
    onClick,
    drawerType,
    ...isCMW ? { stockStatusData } : {}
  });
  if ((missingProps == null ? void 0 : missingProps.length) > 0) {
    console.error(`Missing props: ${missingProps}`);
    return null;
  }
  moduleSettings.composable_window.forEach(
    (curr) => composableData[curr.text_only.development_field_key] = curr.text_only.body
  );
  return /* @__PURE__ */ jsxs(MainContainer, { "data-testid": COMPONENT_NAME, children: [
    /* @__PURE__ */ jsx(
      Analytics,
      {
        analyticData: {
          component: {
            type: "ui"
          },
          trackType: "navigation"
        },
        children: /* @__PURE__ */ jsx(
          LocationSelectorButton,
          {
            isCMW,
            ariaLabel: preferredWarehouse ? `${(_a = preferredWarehouse.name) == null ? void 0 : _a[0].value}, ${composableData[COMPOSABLE_DATA_ARIA_LABEL]}` : "",
            value: preferredWarehouse ? (_b = preferredWarehouse.name) == null ? void 0 : _b[0].value : isCMW ? composableData[COMPOSABLE_DATA_CHANGE_MY_WAREHOUSE] : composableData[COMPOSABLE_DATA_SET_MY_WAREHOUSE],
            Icon: isCMW ? StyledWarehouseIcon : StyledLocationIcon,
            iconTitle: isCMW ? composableData[COMPOSABLE_DATA_ICON_TITLE] : void 0,
            label: composableData[COMPOSABLE_DATA_MY_WAREHOUSE],
            onClick,
            showLabel,
            stockStatusData,
            analyticsIdentifier,
            uniqueId: "WarehouseSelector"
          }
        )
      }
    ),
    !isCMW && displayOpenHours && shouldShowHours && /* @__PURE__ */ jsx(Fragment, { children: showOpeningHours ? /* @__PURE__ */ jsx(
      OpeningHours,
      {
        entry: moduleSettings,
        holidays: preferredWarehouse.holidays,
        hours: preferredWarehouse.hours,
        sx: { paddingLeft: "20px" },
        timeZone: preferredWarehouse.timeZone,
        variant: "t7"
      }
    ) : /* @__PURE__ */ jsx(
      Skeleton,
      {
        height: "18px",
        width: "120px",
        sx: { marginLeft: "20px" }
      }
    ) })
  ] });
}
export {
  WarehouseSelectorUI
};
